import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-home-conteudos',
    templateUrl: './_conteudos.component.html',
    styleUrls: ['./_conteudos.component.css']
})

export class Home_ConteudosComponent {

    constructor(
        private router: Router
    ) {}

        fnPassParameter(idRelatorio: string, dsRelatorio: string){
            this.router.navigate(['/solicitacoes-especiais', idRelatorio, dsRelatorio]);
        }
}
